import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

//------------------------------------------------------------------------------
//                  Отправить запрос на добавление реакции
//------------------------------------------------------------------------------
export const loadNewReactions = async ({content_type, object_id}) => {
  try {
    const endpoint = `${ backendUrl }/api/reactions/post-reaction/?content_type=${content_type}&object_id=${object_id}`;
    const options = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    };
    const response = await fetchWithAuth(endpoint, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка при изменении реакций: HTTP error! Status: ${ response.status }`);
    }
    return await response.json();
  } catch (error) {
    console.error('Программная ошибка изменения реакций:', error);
    throw error;
  }
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx